import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, catchError, firstValueFrom, map, of } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';
import { IdentityVerificationComponent } from '../../core/components/identity-verification/identity-verification.component';
import { AuthErrorService, AuthService, PnpLoginService, PnpUserService } from '@pn-plus/pnp-services';
import { LoginService } from '../../core/services/login.service';
import { ITokenInfo, ITokenInfo2FA } from 'libs/pnp-services/src/lib/api/_models/pnp-token-info.model';
import { ILoginTwoFactorPayload, ILoginTwoFactorResendPayload } from 'libs/pnp-services/src/lib/api/login/pnp-login.model';
import { IRegistrationResponse, IUserPhoneNumberConfirmedPayload } from 'libs/pnp-services/src/lib/api/user/pnp-user.model';
import { environment } from '@pn-plus/pnp-environment';

@Component({
    selector: 'pnl-identity-verification',
    templateUrl: './identity-verification.component.html',
    styleUrls: ['./identity-verification.component.scss'],
})
export class IdentityVerificationPageComponent implements OnInit {
    @ViewChild('identityVerification') identityVerificationRef !: IdentityVerificationComponent;
    
    public isLoading = false;
    public activeError: any;
    public errors = {
        Default: 0,
        CodeNotValid: 1,
        TokenInvalidated: 2,
        TokenTypeNotValid: 3,
        TokenTypeValid: 4
    };
    get phoneNumber(): string {
        const authModel = this.authService.getAuthModel();
        const twoFactorToken = authModel?.loginResponse?.twoFactorToken;
        if(twoFactorToken) {
            return twoFactorToken.userPhoneNumberLastFour || '****';
        } else {
            const number = authModel?.userResponse?.phoneNumber || '****'
            return number.length > 4 ? number.substr(number.length - 4, 4) : number;
        }
    }
    constructor(
        public authService: AuthService,
        public loginService: LoginService,
        private authErrorService: AuthErrorService,
        private pnpLoginService: PnpLoginService,
        private pnpUserService: PnpUserService,
    ) {
        
    }

    getTwoFactorToken(): ITokenInfo2FA | undefined {
        const authModel = this.authService.getAuthModel();
        return authModel?.loginResponse?.twoFactorToken;
    }

    async ngOnInit() {
        this.setBusy(true);
        const authModel = this.authService.getAuthModel();
        const twoFactorToken = authModel?.loginResponse?.twoFactorToken;
        if(twoFactorToken) {
            // const response = await firstValueFrom(this.resend2FAConfirmationCode(twoFactorToken));
            // if(response) {
            //     const authModel = this.authService.getAuthModel();
            //     if(authModel.loginResponse) {
            //         authModel.loginResponse.twoFactorToken = <any>response;
            //         this.authService.updateAuthModel(authModel);
            //     }
            // }
        } else {
            if(!authModel.registrationResponse?.hasPhoneNumberConfirmed && !authModel.phoneNumberResponse) {
                const response = await firstValueFrom(this.resendConfirmationCode());
                const authModel = this.authService.getAuthModel();
                if(authModel.phoneNumberResponse) {
                    authModel.phoneNumberResponse = <any>response;
                }
                if(authModel.loginResponse) {
                    authModel.loginResponse.accessToken = <any>response;
                }
                this.authService.updateAuthModel(authModel);
            }
        }
        this.setBusy(false);
    }

    
    resend2FAConfirmationCode(token: ITokenInfo2FA): Observable<any> {
        const payload: ILoginTwoFactorResendPayload = {
            twoFactorToken: token.jwt
        }
        return this.pnpLoginService.postLoginTwoFactorResend(payload)
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    // TODO: Handle error here
                    this.activeError = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(errorResponse);
                }),
                map((response) => {
                    return response;
                })
            );
    }

    resendConfirmationCode() {
        return this.pnpUserService.putUserPhoneNumberResend()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    // TODO: Handle error here
                    this.activeError = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(errorResponse);
                }),
                map((response) => {
                    return response;
                })
            );
    } 

    async onIdentityVerificationEntered(code: string) {
        this.setBusy(true);
        if(this.isTwoFactor()) {
            // TwoFactor authentication logic
            const twoFactorToken = this.getTwoFactorToken();
            const response = await firstValueFrom(this.verifyTwoFactor(code, twoFactorToken));
            document.location.href = environment.pnDashboardUrl;
            return;
        } else {
            // Registration - phone number confirmation logic
            const error = await firstValueFrom(this.verifyCode(code));
            if(!error) {
                const error = await firstValueFrom(this.updateHasPhoneNumberConfirmed());
                if(!error) {
                    const response = await firstValueFrom(this.getUserRegistration());
                    if(response) {
                        const authModel = this.authService.getAuthModel();
                        authModel.registrationResponse = response;
                        this.authService.updateAuthModel(authModel);
                        this.loginService.navigateRegistration(authModel);
                    }
                }
            }
        }
        this.identityVerificationRef.codeInput.reset();
        this.setBusy(false);
    }

    getUserRegistration(): Observable<IRegistrationResponse> {
        return this.pnpUserService.getUserRegistration()
            .pipe(catchError(errorResponse => {
                this.activeError = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                return of(errorResponse)
            })
        );
    }

    isTwoFactor() {
        const authModel = this.authService.getAuthModel();
        return authModel?.loginResponse?.twoFactorToken; 
    }

    updateRegistration() {
        // const authModel = this.authService.getAuthModel();
        // if(this.isTwoFactor()) {

        // } else {
        //     authModel.phoneNumberResponse = this.payload;
        //     if(authModel.registrationResponse) {
        //         authModel.registrationResponse.hasPhoneNumberConfirmed = true;
        //     }
        //     this.authService.updateAuthModel(authModel);
        // }
        // return authModel;
    }

    updateHasPhoneNumberConfirmed(): Observable<any> {
        return this.pnpUserService.putRegistrationHasPhoneNumberConfirmed()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    // TODO: Handle error here
                    return of(errorResponse);
                }),
                map((response) => {
                    return response;
                })
            );
    }

    verifyTwoFactor(code: string, token: ITokenInfo2FA | undefined): Observable<any> {
        const payload: ILoginTwoFactorPayload = {
            twoFactorToken: <string>token?.jwt,
            code: code,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        return this.pnpLoginService.postLoginTwoFactor(payload)
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.identityVerificationRef.error = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(errorResponse);
                }),
                map((response: any) => {
                    return response;
                })
            )
    }

    verifyCode(code: string): Observable<ITokenInfo> {
        // 1. Phone confirmation
        const authModel = this.authService.getAuthModel();

        const payload: IUserPhoneNumberConfirmedPayload = {
            phoneNumberChangeToken: <any>authModel.phoneNumberResponse?.jwt,
            code: code
        }

        return this.pnpUserService.putUserPhoneNumberConfirmed(payload)
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.identityVerificationRef.error = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(errorResponse);
                }),
                map((response: any) => {
                    return response;
                })
            )

        // 2. Password reset
        // const payload: IUserPasswordResetVerificationPayload = {
        //     passwordResetToken: this.payload.jwt,
        //     code: code
        // }
        // return this.authService.putUserPasswordResetVerification(payload)
        //     .pipe(
        //         catchError((errorResponse: HttpErrorResponse) => {
        //             this.identityVerificationRef.activeError = this.getErrorByType(errorResponse?.error?.type);
        //             return of(null);
        //         }),
        //         map((response: any) => {
        //             return response;
        //         })
        //     )
    }
    
    setBusy(flag: boolean): void {
        this.isLoading = flag;
    }

    async onResendClicked($event: any) {
        const authModel = this.authService.getAuthModel();
        if(this.isTwoFactor()) {
            const token = this.getTwoFactorToken();
            if(token) {
                const resendToken = await firstValueFrom(await this.resend2FAConfirmationCode(token));
                if(resendToken?.jwt && authModel.loginResponse){
                    authModel.loginResponse.twoFactorToken = resendToken; 
                }
            }
        } else {
            const resendToken = await firstValueFrom(this.resendCode());
            if(resendToken?.jwt){
                authModel.phoneNumberResponse = resendToken; 
            }
        }
        this.authService.updateAuthModel(authModel);


        // const payload: IUserPasswordResetResendPayload = {
        //     passwordResetToken: this.payload.jwt
        // }
        // const resendToken = await firstValueFrom(await this.resendCode(payload));
        // if(resendToken?.jwt){
        //     this.payload.jwt = resendToken.jwt; 
        // }
    }

    resendCode() {

        return this.pnpUserService.putUserPhoneNumberResend()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.activeError = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(null);
                }),
                map((response: any) => {
                    return response;
                })
            )
    }

    // resendCode(payload: IUserPasswordResetResendPayload) {
    //     return this.authService.putUserPasswordResetResend(payload)
    //         .pipe(
    //             catchError((errorResponse: HttpErrorResponse) => {
    //                 this.activeError = this.getErrorByType(errorResponse?.error?.type);
    //                 return of(null);
    //             }),
    //             map((response: any) => {
    //                 return response;
    //             })
    //         )
    // }

}
